import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items, testIdPrefix = "faq" }) {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid={`${testIdPrefix}-list`} className="divide-y divide-[#27272a] border-y border-[#27272a]">
      {items.map((item, idx) => {
        const isOpen = open === idx;
        return (
          <div
            key={idx}
            data-testid={`${testIdPrefix}-item-${idx}`}
            className="py-6"
          >
            <button
              onClick={() => setOpen(isOpen ? -1 : idx)}
              data-testid={`${testIdPrefix}-toggle-${idx}`}
              className="w-full flex items-center justify-between gap-6 text-left group"
            >
              <span className="font-heading text-lg md:text-xl text-white group-hover:text-[#C8A24B] transition-colors">
                {item.q}
              </span>
              <span className="flex-shrink-0 w-8 h-8 border border-[#27272a] flex items-center justify-center text-[#C8A24B]">
                {isOpen ? <Minus size={14} /> : <Plus size={14} />}
              </span>
            </button>
            {isOpen && (
              <div className="mt-5 pr-14 text-[#a1a1aa] leading-relaxed max-w-3xl">
                {item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
